var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cited-push-template-config"},[_c('div',{staticClass:"page-content"},[_c('templateConfig',{attrs:{"description":'在集群层面，对被引推送的邮件模板进行配置管理。',"template-options":_vm.citationTypes},on:{"toDetail":_vm.toDetail}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }